export const IMAGES = {
  hero: "https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxkdWJhaSUyMGx1eHVyeSUyMGFyY2hpdGVjdHVyZSUyMHNreWxpbmUlMjBkdXNrJTIwbmlnaHQlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3OTI5OTY1NjZ8MA&ixlib=rb-4.1.0&q=85",
  night: "https://images.unsplash.com/photo-1462007895615-c8c073bebcd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxkdWJhaSUyMGx1eHVyeSUyMGFyY2hpdGVjdHVyZSUyMHNreWxpbmUlMjBkdXNrJTIwbmlnaHQlMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3OTI5OTY1NjZ8MA&ixlib=rb-4.1.0&q=85",
  staircase: "https://images.unsplash.com/photo-1770154584068-ed418529cf9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWwlMjBtb2Rlcm4lMjBidWlsZGluZyUyMGludGVyaW9yJTIwbWFyYmxlJTIwZ2xhc3N8ZW58MHx8fHwxNzkyOTk2NTczfDA&ixlib=rb-4.1.0&q=85",
  hallway: "https://images.unsplash.com/photo-1702048853717-d1355cba332e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWwlMjBtb2Rlcm4lMjBidWlsZGluZyUyMGludGVyaW9yJTIwbWFyYmxlJTIwZ2xhc3N8ZW58MHx8fHwxNzkyOTk2NTczfDA&ixlib=rb-4.1.0&q=85",
  concrete: "https://images.unsplash.com/photo-1780369088492-e6fe0ce8ef4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBkZXRhaWwlMjBtb2Rlcm4lMjBidWlsZGluZyUyMGludGVyaW9yJTIwbWFyYmxlJTIwZ2xhc3N8ZW58MHx8fHwxNzkyOTk2NTczfDA&ixlib=rb-4.1.0&q=85",
};

export const PHONE_DISPLAY = "+971 58 560 8119";
export const PHONE_TEL = "tel:+971585608119";
export const WHATSAPP_URL = "https://wa.me/971585608119";

export const NAV_LINKS = [
  { label: "Solutions", id: "solutions" },
  { label: "Lending criteria", id: "criteria" },
  { label: "How it works", id: "how-it-works" },
  { label: "About", id: "about" },
  { label: "FAQ", id: "faq" },
];

export const CREDIBILITY = [
  "20+ years in business & finance",
  "UAE banks & lenders",
  "Residents & non-residents",
  "Discreet, one-to-one service",
];

export const HERO_STATS = [
  { value: "AED 3m+", label: "Specialist facility sizes" },
  { value: "40–70%", label: "Loan to value, by structure*" },
  { value: "Global", label: "Income & assets considered" },
];

export const BENEFITS = [
  {
    title: "Unlock capital without selling",
    text: "Release the equity sitting in your completed UAE property while retaining ownership and its rental income.",
  },
  {
    title: "Global income counts",
    text: "Business income, overseas earnings and rental income are all considered, wherever in the world they are earned.",
  },
  {
    title: "Your assets, working harder",
    text: "We assess what you actually own and earn, not just a payslip, and structure finance around the whole picture.",
  },
  {
    title: "Fast & discreet",
    text: "One adviser, one conversation, no call centres. Your affairs stay private, and well-prepared cases move quickly.",
  },
];

export const SOLUTIONS = [
  { n: "01", name: "Structured & Asset-Backed Finance", text: "Bespoke facilities secured against your property and investment assets, structured around your whole financial position." },
  { n: "02", name: "Property Equity Release", text: "Release capital tied up in completed UAE investment property without selling the asset." },
  { n: "03", name: "Investment Property Acquisitions", text: "Funding to acquire investment property, from individual units to whole floors and buildings." },
  { n: "04", name: "Commercial Property Finance", text: "Funding for commercial and mixed-use property, including offices, retail and income-producing assets." },
  { n: "05", name: "Bridging Finance", text: "Short-term funding arranged at pace, when timing matters more than process." },
  { n: "06", name: "Development & Refurbishment Finance", text: "Structured funding for development schemes and the works that lift a property's value and rental performance." },
  { n: "07", name: "Portfolio Funding & Capital Restructuring", text: "One considered facility across multiple properties, with capital restructuring where it strengthens your position." },
  { n: "08", name: "Off-Plan Completion", text: "Finance for handover and final payments when your off-plan purchase approaches completion." },
];

export const SOLUTIONS_DISCLAIMER =
  "All terms are indicative and subject to lender approval, valuation and status. Minimum specialist facility AED 3m.";

export const MARQUEE_ITEMS = [
  "Structured & Asset-Backed Finance",
  "Property Equity Release",
  "Investment Property Acquisitions",
  "Commercial Property Finance",
  "Bridging Finance",
  "Development & Refurbishment",
  "Portfolio Funding",
  "Off-Plan Completion",
];

export const CRITERIA = [
  {
    label: "Specialist facility size",
    value: "AED 3m+",
    text: "Structured facilities from AED 3 million. Conventional mortgages follow separate lender criteria.",
  },
  {
    label: "Loan to value",
    value: "40–70%",
    text: "Depending on the structure, the property and your profile. Indicative only, never guaranteed.",
  },
  {
    label: "Portfolio",
    value: "2+ properties",
    text: "Most structured facilities assume two or more completed properties. A single property may qualify for capital release where other criteria are met.",
  },
  {
    label: "Property",
    value: "Completed",
    text: "Completed investment property in the UAE, held with a clear title deed.",
  },
  {
    label: "Income",
    value: "Global",
    text: "Business income, rental income and your wider asset position are considered, not just a UAE salary.",
  },
  {
    label: "Borrowers",
    value: "Res & non-res",
    text: "UAE residents and non-residents alike, borrowing personally or through corporate structures.",
  },
];

export const COMPARISON = [
  {
    row: "Income",
    standard: "Verified income and affordability criteria",
    structured: "Broader assessment of income, assets and financial position, subject to lender requirements",
  },
  {
    row: "Assets",
    standard: "Property security assessed alongside income and liabilities",
    structured: "Eligible property and investment assets may support bespoke funding",
  },
  {
    row: "Use of funds",
    standard: "Property purchase, refinancing and eligible equity release",
    structured: "Property acquisitions, business funding and approved investment purposes",
  },
  {
    row: "Repayments",
    standard: "Typically scheduled capital and interest payments",
    structured: "May include interest-only or tailored repayment structures",
  },
  {
    row: "Approach",
    standard: "Established mortgage products and lending criteria",
    structured: "Individually structured facilities through suitable funding partners",
  },
];

export const FINDER = [
  { scenario: "I own property and want to release cash", solution: "Capital Release" },
  { scenario: "My income is from my business or overseas", solution: "Equity Release" },
  { scenario: "My handover payment is due", solution: "Off-Plan Completion" },
  { scenario: "The bank said no / I need it fast", solution: "Bridging Finance" },
  { scenario: "I want to buy a building or a whole floor", solution: "Acquisition Finance" },
];

export const STEPS = [
  {
    n: "01",
    title: "Consultation",
    text: "A free, confidential conversation to understand your properties, financial position and investment objectives, allowing us to explore suitable financing solutions.",
  },
  {
    n: "02",
    title: "Structure & terms",
    text: "We assess your assets and income, then present the structures and indicative terms that fit, from suitable UAE banks and lenders.",
  },
  {
    n: "03",
    title: "Credit approval",
    text: "Your case is packaged properly and taken to credit with the chosen lender, with one adviser beside you throughout.",
  },
  {
    n: "04",
    title: "Completion",
    text: "Valuation, legal work and documentation are completed, and funds are released, ready for your next move.",
  },
];

export const FUNDING_ROWS = [
  { label: "Facility", value: "AED 10,000,000" },
  { label: "12 months' interest held", value: "− AED 700,000" },
  { label: "Fees held", value: "− AED 200,000" },
];

export const AUDIENCES = [
  {
    title: "Property investors",
    text: "Owners of completed UAE investment property who want their capital working harder, without selling what they have built.",
  },
  {
    title: "Business owners",
    text: "Founders whose real income sits in their business, not on a payslip, and who need a lender to see it.",
  },
  {
    title: "International investors",
    text: "Non-residents building, restructuring or releasing capital from a UAE property position.",
  },
  {
    title: "Agents & partners",
    text: "Introduce clients who need specialist property finance, and stay close to the outcome.",
    cta: true,
  },
];

export const FAQS = [
  {
    q: "How many properties do I need?",
    a: "Most structured facilities assume two or more completed properties. Capital release against a single property can be possible where the other criteria are met. No existing property is needed for acquisition finance or a conventional mortgage.",
  },
  {
    q: "Does LE Capital also assist with traditional mortgages?",
    a: "Yes. While our primary focus is bespoke real estate finance and structured lending, we also work with banking partners to explore conventional mortgage solutions where these are better suited to a client's circumstances and objectives. All services are subject to lender eligibility and applicable regulatory permissions.",
  },
  {
    q: "Can my overseas income or assets be used?",
    a: "Yes. We consider global business income, rental income and assets, wherever in the world they are held.",
  },
  {
    q: "How much can I borrow?",
    a: "Structured facilities start from AED 3 million. Loan to value typically ranges from 40% to 70%, depending on the structure, the property and your profile. All terms are indicative and subject to lender approval, valuation and status.",
  },
  {
    q: "Can non-residents borrow?",
    a: "Yes. We work with both resident and non-resident borrowers, in personal names and through corporate structures.",
  },
  {
    q: "Are you a bank or a lender?",
    a: "No. LE Capital is a specialist property finance advisory. Finance itself is provided by UAE banks and lenders, subject to their approval, valuation and status.",
  },
  {
    q: "How do your fees work?",
    a: "Our fees are explained and agreed with you in writing before you commit to anything. The initial consultation is free and entirely without obligation.",
  },
];

export const FINANCE_TYPE_OPTIONS = [
  { value: "Equity Release", label: "Property Equity Release" },
  { value: "Capital Release", label: "Structured / Asset-Backed Finance" },
  { value: "Acquisition Finance", label: "Investment Property Acquisition" },
  { value: "Commercial Property Finance", label: "Commercial Property Finance" },
  { value: "Off-Plan Completion", label: "Off-Plan Completion" },
  { value: "Bridging Finance", label: "Bridging Finance" },
  { value: "Refurbishment Finance", label: "Development & Refurbishment Finance" },
  { value: "Development Finance", label: "Development & Refurbishment Finance" },
  { value: "Portfolio Finance", label: "Portfolio Funding & Capital Restructuring" },
  { value: "Conventional Mortgage", label: "Conventional Mortgage" },
  { value: "Partnership / Referral", label: "Partnership / Referral" },
  { value: "Not sure / Other", label: "Not sure / Other" },
];

export const PROPERTY_OPTIONS = ["None yet, looking to buy", "1", "2", "3", "4", "5 or more"];

export const PRIVACY_SECTIONS = [
  {
    title: "Who we are",
    body: "LE Capital is a specialist property finance advisory based in Dubai, United Arab Emirates. LE Capital is a trading name of Love Exclusive LLC FZ. This policy explains how we handle personal information submitted through this website.",
  },
  {
    title: "What we collect",
    body: "When you submit the consultation enquiry form, we collect your full name, mobile / WhatsApp number, email address, the number of completed properties you own (if any), the amount of finance you are looking for, the type of finance you are interested in, and any message you choose to include. We do not request sensitive financial documents through this website.",
  },
  {
    title: "How we use your information",
    body: "We use your information solely to respond to your enquiry, arrange a consultation and assess how we may be able to help. Enquiry details are sent to our advisory team by email. We do not sell your information, and we do not use it for unrelated marketing without your consent.",
  },
  {
    title: "Sharing and storage",
    body: "Your enquiry is transmitted to our business email system for handling by our team. Where your enquiry progresses, relevant details may be shared with UAE banks and lenders only with your knowledge and for the purpose of arranging finance. We retain enquiry records only for as long as needed to handle your enquiry and meet legal obligations.",
  },
  {
    title: "Your rights",
    body: "Under the UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL), you may request access to, correction of, or deletion of your personal data. To exercise any of these rights, contact us using the details below.",
  },
  {
    title: "Contact",
    body: "For any privacy question or request, contact LE Capital through the enquiry form on this website or via WhatsApp.",
  },
];

export const UI = {
  docTitle: "LE Capital | Real Estate Finance. Intelligently Structured. | Dubai, UAE",
  navCta: "Book a consultation",
  menuOpen: "Open menu",
  menuClose: "Close menu",
  heroEyebrow: "Real Estate Finance · Intelligently Structured",
  heroTitleA: "Specialist finance",
  heroTitleB1: "for",
  heroTitleEm: "investors",
  heroSub: "Your Assets. Your Ambitions. Our Expertise.",
  heroBody: [
    "At LE Capital, we specialise in structuring tailored finance solutions for property investors, developers, business owners and high-net-worth individuals.",
    "We take a comprehensive approach to understanding our clients' financial position, property portfolios and investment objectives, exploring funding opportunities through our network of banks and specialist finance providers.",
    "Whether you're looking to unlock equity from existing assets, finance your next acquisition, raise capital for a development or expand your investment portfolio, our focus is on identifying the most suitable funding structure for your ambitions.",
  ],
  heroCtaPrimary: "Book a Private Consultation",
  heroCtaSecondary: "See how it works",
  wordmarkAlt: "LE Capital home",
  heroImageAlt: "Dubai skyline at dusk, premium architectural towers",
  benefitsLabel: "Why investors use us",
  benefitsTitle: "Finance that sees the whole picture",
  benefitsBody:
    "A standard mortgage looks at a payslip. We look at what you actually own and earn, wherever it is.",
  flexibleLabel: "Flexible use of funds",
  flexibleText: "Buy your next property, fund a handover, expand your business or reinvest.",
  benefitsImageAlt: "Luxury Dubai terrace with an infinity pool overlooking the skyline and Burj Khalifa at golden hour",
  solutionsLabel: "What we arrange",
  solutionsTitle: "Finance for every stage of investing in the UAE",
  criteriaLabel: "Lending criteria",
  criteriaTitle: "Clear parameters, structured around you",
  criteriaBody:
    "Every case is considered individually. These are the starting points most of our lenders work from for structured facilities.",
  comparisonLabel: "The difference",
  comparisonTitle: "Traditional mortgage vs. structured finance",
  comparisonAspect: "Assessment",
  comparisonStandard: "Traditional mortgage",
  comparisonStructured: "Structured finance",
  comparisonNote:
    "LE Capital explores both conventional and specialist finance solutions, helping clients identify the most appropriate funding approach for their circumstances and objectives.",
  finderLabel: "Not sure what you need?",
  finderTitle: "Start with your situation",
  finderBody: "Tell us what you're trying to do. We'll find the structure that fits.",
  hiwLabel: "How it works",
  hiwTitle: "Four steps from first call to funds",
  fundingLabel: "An illustrative example",
  fundingTitle: "Your first 12 months are taken care of from day one",
  fundingBody:
    "Certain structures allow the first year's interest and fees to be held within the loan itself, so the facility services its own first year while your capital goes to work. These remain borrowing costs within the facility, not waived interest.",
  fundingNet: "In your account",
  fundingNetValue: "AED 9,100,000",
  fundingFootnote:
    "Based on an indicative 7% rate. Illustrative only. Not an offer of finance. All terms are subject to lender approval, valuation and status.",
  whoLabel: "Who we help",
  whoTitle: "Built for investors, not homebuyers",
  partnerCta: "Become a partner",
  aboutLabel: "About LE Capital",
  logoAlt: "LE Capital monogram logo",
  aboutTitle: "An investor who understands investors",
  aboutBio: [
    "Natalia McKenzie is an entrepreneur, property investor and business and finance strategist with over 20 years of experience spanning business development, financial solutions, investment and relationship management.",
    "Throughout her career, Natalia has built an extensive network of business owners, investors, financial professionals and industry connections. Known for her ability to connect the right people with the right opportunities, she brings together relationships, commercial understanding and strategic thinking to help clients explore intelligent financial solutions.",
    "Having built and operated businesses and invested in property herself, Natalia understands the ambitions and challenges faced by entrepreneurs and investors. She founded LE Capital with a vision to provide a more personal, discreet and considered approach to property finance and capital solutions.",
    "Her philosophy is simple. Understand the individual, recognise the opportunity and bring together the expertise and relationships needed to explore the most appropriate path forward.",
  ],
  founderName: "Natalia McKenzie",
  founderRole: "Founder · LE Capital",
  founderPhotoAlt: "Natalia McKenzie, Founder of LE Capital",
  aboutNote: "Biography shown pending final approved copy.",
  faqLabel: "FAQ",
  faqTitle: "Questions we're often asked",
  consultLabel: "Speak to us",
  consultTitle: "Book a free, confidential consultation",
  consultBody:
    "Tell us about your property portfolio and financing objectives. We'll explore the options best suited to your requirements.",
  consultPreferTalk: "Prefer to talk now?",
  consultWhatsapp: "WhatsApp us",
  formName: "Full name *",
  formPhone: "Mobile / WhatsApp *",
  formEmail: "Email address *",
  formProperties: "Completed properties owned (optional)",
  formAmount: "Amount needed (AED)",
  formAmountPlaceholder: "e.g. 3000000",
  formLookingFor: "I'm looking for *",
  formMessage: "Message (optional)",
  formSelect: "Select",
  formConsent:
    "I agree to LE Capital contacting me about my enquiry and handling my details as described in the privacy policy. *",
  formSubmit: "Request a call back",
  formSubmitting: "Sending…",
  errName: "Please enter your full name.",
  errPhone: "Enter a valid number, e.g. +971 58 560 8119.",
  errEmail: "Enter a valid email address.",
  errSelect: "Please select an option.",
  errAmount: "Enter a valid amount.",
  errConsent: "Please confirm you agree to the privacy policy.",
  toastReview: "Please review the highlighted fields.",
  toastSuccess: "Your enquiry has been received.",
  toastError: "Could not send your enquiry. Please reach us on WhatsApp.",
  successTitle: "Thank you for contacting LE Capital.",
  successBody: "Your enquiry has been received. Our team will be in touch.",
  successWhatsapp: "Message us on WhatsApp",
  successReset: "Send another enquiry",
  footerTagline: "Real Estate Finance. Intelligently Structured.",
  footerTrading: "LE Capital is a trading name of Love Exclusive LLC FZ.",
  footerLocation: "Dubai, United Arab Emirates.",
  footerExplore: "Explore",
  footerContact: "Contact",
  footerContactLink: "Contact",
  footerPrivacy: "Privacy policy",
  footerWhatsapp: "WhatsApp",
  footerDisclaimer:
    "LE Capital is not a lender. All finance is provided by UAE banks and lenders and is subject to lender approval, valuation and status. Any terms, rates and figures shown on this site are indicative only and do not constitute an offer of finance. Content is provided for general information and is pending final legal and compliance review.",
  footerCopyright: "LE Capital · Love Exclusive LLC FZ",
  privacyLabel: "Legal",
  privacyTitle: "Privacy policy",
  privacyBadge: "Draft — pending legal review",
  privacyUpdated: "Last updated: 26 October 2026",
  privacyBack: "Back to home",
};
